import { Outlet } from "@mui/icons-material";
import React from "react";

function SignIn() {
  return (
    <>
    <div className="Signin">
      <ul className="header">
        <a href="/">
          <div id="logoImg" />
        </a>
      </ul>
    </div>
    <Outlet />
    </>
  );
}

export default SignIn;
